// extracted by mini-css-extract-plugin
export default {"item":"flw3HLn0","columns":"FifZGgIC"};